import React, { useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import NavigateButton from '../buttons/NavigateButton';
import ErrorSelecter from '../buttons/ErrorSelecter';

function Ex1_2026_LearnerMain() {
  const navigate = useNavigate();
  const location = useLocation();
  const userId = location.state?.userId || null;
  const [errorScore, setErrorScore] = useState(null);

  // userIdがない場合はログイン画面にリダイレクト
  React.useEffect(() => {
    if (!userId) {
      navigate('/learner-login');
    }
  }, [userId, navigate]);

  const handleBack = () => {
    setErrorScore(null);
    navigate('/learner-login');
  };

  if (!userId) return null;

  const isErrorScoreSelected = errorScore !== null;

  return (
    <main className="container-center">
      <section className="card">
        <header className="card-header flex items-center justify-between">
          <div>
            <h1 className="text-2xl font-semibold">メインメニュー</h1>
            <p className="text-subtitle mt-1">機能を選択してください</p>
          </div>
          <div className="ml-4 flex flex-col gap-1">
            <span className="badge badge--green">
              ユーザーID: {userId}
            </span>
            <span className={`badge ${isErrorScoreSelected ? 'badge--green' : 'badge--red'}`}>
              誤りスコア：{errorScore !== null ? errorScore : 'N/A'}
            </span>
          </div>
        </header>
        <div className="form-group">
          {!isErrorScoreSelected && (
            <ErrorSelecter errorScore={errorScore} setErrorScore={setErrorScore} />
          )}
          {!isErrorScoreSelected && (
            <p className="text-warning">
              ⚠️ 管理者が誤り判定をしていません。誤りスコアを選択してから次に進んでください
            </p>
          )}
          <NavigateButton
            to="/viewer"
            buttonText="２次元画像との比較を行う（演習1）"
            state={{ userId: parseInt(userId), errorScore }}
            disabled={!isErrorScoreSelected}
          />
          <NavigateButton
            to="/suggest2"
            buttonText="修正過程を少しずつ見る（演習2）"
            state={{ userId: parseInt(userId), errorScore }}
            disabled={!isErrorScoreSelected}
            className="btn--secondary"
          />
          <button onClick={handleBack} className="btn btn--gray w-full">
            ログアウト
          </button>
        </div>
      </section>
    </main>
  );
}

export default Ex1_2026_LearnerMain;